import { AuthProvider, signInWithPopup } from "firebase/auth";
import {
  initFirebase,
  clearFirebaseLocalStorage,
} from "@core/services/api/firebase";
import { apiRequest } from "@core/services/api/apiRequest";

export async function loginUserWithOAuth(
  provider: AuthProvider,
  onError?: () => void
) {
  const apiEndpoint = "/auth/login/";

  try {
    // Ensure firebase is initialized
    const auth = await initFirebase();

    // Sign in or register user with OAuth provider
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    // Get Firebase token
    const idToken = await user.getIdToken();

    // Prepare API request body
    const body = {
      firebase_token: idToken,
    };

    // Make API call to backend (requireAuth=false since user is logging in)
    const response = await apiRequest(apiEndpoint, "POST", body, false);

    return { authToken: idToken, ...response };
  } catch (error) {
    clearFirebaseLocalStorage();

    onError?.();

    throw error;
  }
}

export default loginUserWithOAuth;
